import { FuseNavigation } from "@fuse/types";

export const navigation: FuseNavigation[] = [
    {
        id: "applications",
        title: "",
        translate: "NAV.APPLICATIONS",
        type: "group",
        children: [
            // {
            //     id       : 'sample',
            //     title    : 'Sample',
            //     translate: 'NAV.SAMPLE.TITLE',
            //     type     : 'item',
            //     icon     : 'email',
            //     url      : '/sample',
            //     badge    : {
            //         title    : '25',
            //         translate: 'NAV.SAMPLE.BADGE',
            //         bg       : '#F44336',
            //         fg       : '#FFFFFF'
            //     }
            // },
            {
                id: "home",
                title: "Inicio",
                type: "item",
                icon: "today",
                url: "home",
            },
            {
                id: "profile",
                title: "Perfil",
                type: "item",
                icon: "person",
                url: "perfil",
            },
            {
                id: "schedule",
                title: "Agenda",
                type: "item",
                icon: "today",
                url: "agenda",
            },
            {
                id: "checkin",
                title: "Check-in",
                type: "item",
                icon: "today",
                url: "checkin",
            },
            {
                id: "exams",
                title: "Exames",
                type: "item",
                icon: "healing",
                url: "exames",
            },
            {
                id: "logout",
                title: "Sair",
                type: "item",
                icon: "exit_to_app",
                url: "logout",
            },
        ],
    },
];
